module.exports = __webpack_public_path__ + "ce25837339826640e4c91b0d81eecac5.svg";